import React from 'react';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Avatar from 'components/core/Avatar';
// Models
import {
  sortRegularElements, color, getOnDemand,
} from 'models/cpm/parkingCategory';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';
import ParkingCategoryTitle from './ParkingCategoryTitle';

const buildParkingCategoryItem = (parkingCategory) => ({
  id: parkingCategory.id,
  parkingCategory, // Store whole parking category to use it in ParkingCategoryTitle
  itemCustomIcon: (
    <Avatar backgroundColor={color(parkingCategory)} size={20} variant="rounded">
      <div />
    </Avatar>
  ),
});

const parkingCategoryItemLabel = (parkingCategoryItem) => {
  // Divider
  if (parkingCategoryItem.divider) {
    return '';
  }

  return (
    <ParkingCategoryTitle parkingCategory={parkingCategoryItem.parkingCategory} />
  );
};

const ParkingCategorySelectFieldFilter = ({
  parkingCategoryId, parkingCategories, withOnDemand, onChange,
}) => {
  // Build parking categories array
  // Start with regular ones
  const allParkingCategories = _map(sortRegularElements(parkingCategories), (parkingCategory) => (buildParkingCategoryItem(parkingCategory)));

  // On-demand category
  if (withOnDemand) {
    const onDemandParkingCategory = getOnDemand(parkingCategories);
    if (onDemandParkingCategory) {
      // Add a divider
      allParkingCategories.push({
        id: 'divider_1',
        divider: true,
      });
      // Add the parking category
      allParkingCategories.push(buildParkingCategoryItem(onDemandParkingCategory));
    }
  }

  return (
    <ResourceSelectFieldFilter
      labelId="field.parkingCategory"
      resourceId={parkingCategoryId}
      resources={allParkingCategories}
      displayKey={parkingCategoryItemLabel}
      onChange={onChange}
    />
  );
};

ParkingCategorySelectFieldFilter.propTypes = {
  parkingCategoryId: PropTypes.number,
  parkingCategories: PropTypes.arrayOf(cpmParkingCategoryDataShape).isRequired,
  withOnDemand: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

ParkingCategorySelectFieldFilter.defaultProps = {
  parkingCategoryId: null,
  withOnDemand: true,
};

const mapStateToProps = (state) => ({
  parkingCategories: state.cpmCarparkParkingCategory.list.elements,
});

module.exports = connect(
  mapStateToProps,
)(ParkingCategorySelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategorySelectFieldFilter.js